module.exports = __webpack_public_path__ + "static/img/forget.790d7f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/forget.jpg
// module id = rm1l
// module chunks = 6